import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { compose } from 'redux';
import omit from 'lodash/omit';
import { useNavigate } from 'react-router-dom';
import createCommunityMemberService from '../services/createCommunityMemberService';
import communityMembersService from '../../../../mgmt/communities/services/communityMembers/communityMembersService';
import CommunityMemberForm, { DEFAULT_TEMPLATE_ID } from './CommunityMemberForm';

const EMPTY_MEMBER = { onboardingTemplateId: DEFAULT_TEMPLATE_ID };

const NewCommunityMember = ({
  open,
  createCommunityMemberFetch,
  communityId,
  dispatchCreateCommunityMemberPost,
  returnUrl,
  dispatchCommunityMembersGet,
  isCommunityView,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCreateCommunityMember = useCallback(
    values => {
      let body = values;
      if (body.onboardingTemplateId === DEFAULT_TEMPLATE_ID) {
        body = omit(values, ['onboardingTemplateId']);
      }
      dispatchCreateCommunityMemberPost(
        communityId,
        {
          ...body,
          organisationRoles: body.organisationRoles || [],
          organisation: body.organisation,
          principal: {
            ...body.principal,
            inviteRequest: {
              sendInvitation: true,
              invitationType: 1,
              ...body.principal.inviteRequest,
            },
          },
        },
        () => {
          dispatchCommunityMembersGet(communityId);
          navigate(returnUrl);
        },
        undefined,
        t
      );
    },
    [dispatchCommunityMembersGet, returnUrl, dispatchCreateCommunityMemberPost, communityId, navigate, t]
  );

  if (!open) return null;

  return (
    <CommunityMemberForm
      header={t('createCommunityMember')}
      onSubmit={handleCreateCommunityMember}
      communityId={communityId}
      returnUrl={returnUrl}
      data={EMPTY_MEMBER}
      submitProcessing={createCommunityMemberFetch.pending}
      isCommunityView={isCommunityView}
    />
  );
};

NewCommunityMember.propTypes = {
  dispatchCommunityMembersGet: PropTypes.func.isRequired,
  dispatchCreateCommunityMemberPost: PropTypes.func.isRequired,
  createCommunityMemberFetch: PropTypes.object.isRequired,
  communityId: PropTypes.string.isRequired,
  returnUrl: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  isCommunityView: PropTypes.bool,
};

NewCommunityMember.defaultProps = {
  isCommunityView: false,
};

export default compose(communityMembersService, createCommunityMemberService)(NewCommunityMember);
